export default __webpack_public_path__ + "static/media/marker-9-2.40d30733.jpg";